


















































































import {Vue, Component} from 'vue-property-decorator';
import ItemTable from '@/components/common/ItemTable.vue';
import ExcelCreateButton from '@/components/common/grid/ExcelCreateButton.vue';
import {GetCouponsIssuePlansSummaryRequset} from 'supporter';
import {changeDateFormat} from '@/utils/dateUtils';
import {i18nInObjectList, i18nAllObject} from '@/utils/i18n';
import {popupResize} from '@/utils/ncp';
import {writeExcel} from '@/utils/excel';
import TrTargetGradeGroup from '@/components/member/TrTargetGradeGroup.vue';
@Component({
  components: {
    TrTargetGradeGroup,
    ItemTable,
    ExcelCreateButton
  }
})
export default class CouponPopupDetail extends Vue {
  private paramsSearch = {};
  private get extraInfo() {
    return this.$route.query.couponIssuePlanNo;
  }

  private issueContent: any[] = [];
  private couponIssuePlansSummary: any = {};
  private coupons: any = [];
  private memberGrades: any = [];
  private memberGroups: any = [];
  private totalCount: number = 0;
  private initPageSize: number = 30;
  private mallName: any = '';
  private issueCount: any = '';
  private couponsLength: any = 0;
  private hasCouponIssueMemberType: boolean = true;
  private registerName: any = '';
  private registerYmdt: any = '';
  private periodStartYmdt: any = '';
  private periodEndYmdt: any = '';
  private couponIssueTargetTypeLabel: string = '';
  private issueYmdt: string = '';
  private memberGradesName: string = '';
  private memberGroupsName: string = '';
  private requestYmdt: string = '';
  private contentBottomOption: any = {
    autoHeight: true,
    haveConfigBtn: true,
    haveExcelDownBtn: false
  };
  private size: number = 30;
  private couponNos: string = '';

  private created(): void {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }
  private mounted() {
    this.$nextTick(() => {
      popupResize(913, 746);
    });
  }
  private handleClose(): void {
    window.close();
  }
  private initInfo(data: any): void {
    this.mallName = data.mallName;
    this.issueCount = data.issueCount;
    this.couponsLength = data.coupons.length - 1;
    this.registerName = data.registerAdminName;
    this.registerYmdt = data.registerYmdt && data.registerYmdt.substring(0, 16);
    this.periodStartYmdt = data.periodStartYmdt && data.periodStartYmdt.substring(0, 16);
    this.periodEndYmdt = data.periodEndYmdt && data.periodEndYmdt.substring(0, 16);
    this.issueYmdt = data.issueYmdt && data.issueYmdt.substring(0, 16);
    this.requestYmdt = data.requestYmdt && data.requestYmdt.substring(0, 16);
    this.couponIssueTargetTypeLabel = this.getCouponIssueTargetTypeLabel(data);
    this.hasCouponIssueMemberType = !!data.couponIssueMemberType;
    if (data.memberGrades.length > 0) {
      this.memberGradesName = data.memberGrades[0].name;
    } else {
      this.memberGradesName = '-';
    }
    if (data.memberGroups.length > 0) {
      this.memberGroupsName = data.memberGroups[0].name;
    } else {
      this.memberGroupsName = '-';
    }
  }
  private handleGetCouponIssue(page: number = 1, size: number): void {
    let couponIssueRequest: any = {
      params: {
        couponNos: this.couponNos,
        couponIssuePlanNo: Number(this.$route.query.couponIssuePlanNo),
        sortType: 'COUPON_ISSUE_NO',
        page: 1,
        size: 30
      }
    };
    couponIssueRequest.params.page = page;
    couponIssueRequest.params.size = size;

    this.paramsSearch = JSON.parse(JSON.stringify(couponIssueRequest.params));
    this.$api.getCouponsIssue(couponIssueRequest).then((res) => {
      this.issueContent = [];
      this.issueContent = res.data.contents;
      this.gridProps.options.pageOptions.page = page;
      this.gridProps.options.pageOptions.perPage = size;
      this.totalCount = res.data.totalCount;
      this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
    });
  }
  private search(page: number = 1, size?: number): void {
    if (size) {
      this.size = size;
    }
    if (this.coupons.length === 0) {
      let couponIssue: GetCouponsIssuePlansSummaryRequset = {
        pathParams: {
          couponIssuePlanNo: this.$route.query.couponIssuePlanNo.toString()
        }
      };
      this.$api.getCouponsIssuePlansSummary(couponIssue).then((res) => {
        this.couponIssuePlansSummary = res.data;
        this.initInfo(res.data);
        this.coupons = res.data.coupons;
        this.couponNos = this.getTheCouponsNos(res.data.coupons);
        this.memberGrades = res.data.memberGrades.length > 0 ? res.data.memberGrades : [-1];
        this.memberGroups = res.data.memberGroups.length > 0 ? res.data.memberGroups : [-1];
        this.handleGetCouponIssue(page, this.size);
      });
    } else {
      this.handleGetCouponIssue(page, this.size);
    }
  }
  private async excelDown() {
    let request: any = {
      params: {
        couponNos: this.couponNos,
        couponIssuePlanNo: Number(this.$route.query.couponIssuePlanNo),
        sortType: 'COUPON_ISSUE_NO',
        size: this.totalCount
      }
    };
    const {data} = await this.$api.getCouponsIssue(request);
    if (data.contents.length === 0) {
      alert(this.$t('COMMON_NOT_DATA'));
    } else {
      let keyMapJson = {
        memberNo: 'PROMOTION_COUPON_DETAIL_HEADER_MEMBER_NO',
        memberName: 'PROMOTION_COUPON_DETAIL_HEADER_MEMBER_NAME',
        memberId: 'PROMOTION_COUPON_DETAIL_HEADER_MEMBER_ID',
        memberGradeName: 'PROMOTION_COUPON_DETAIL_HEADER_MEMBER_GRADE',
        couponNo: 'PROMOTION_COUPON_DETAIL_HEADER_COUPON',
        issueYmdt: 'PROMOTION_COUPON_DETAIL_HEADER_ISSUE_YMDT',
        used: 'PROMOTION_COUPON_DETAIL_HEADER_USE_YDMT'
      };
      keyMapJson = i18nAllObject(this, keyMapJson);
      let formatters = {
        used: (cell: any) => {
          if (cell.value) {
            return 'Y';
          } else {
            return 'N';
          }
        }
      };
      let fileName = `coupon_issue_member_detail_${changeDateFormat(new Date(), 'YYYYMMDD_HHmmss')}`;
      writeExcel(data.contents, keyMapJson, fileName, formatters);
    }
  }
  private getTheCouponsNos(data: any): any {
    if (data.length === 0) {
      return;
    }
    let Nos: any = '';
    Nos = data
      .map((item: any): any => {
        return item.no;
      })
      .join(',');
    return Nos;
  }
  private getCouponIssueTargetTypeLabel(data: any): any {
    let name: any = '';
    switch (data.couponIssueTargetType) {
      case 'MEMBER':
        name = '회원별';
        break;
      case 'BIRTHDAY':
        name = '생일자';
        break;
      case 'JOIN':
        name = '신규회원가입';
        break;
      case 'INSTALL_APP':
        name = '신규앱설치';
        break;
      default:
        name = '';
    }
    return name;
  }
  private gridProps = {
    header: {
      height: 34,
      bacground: '#ccc'
    },
    options: {
      columnOptions: {
        minWidth: 50,
        resizable: true
      },
      rowHeight: 28,
      minRowHeight: 28,
      displayRowCount: 30,
      isInitialRequest: true,
      keyColumnName: 'memberNo',
      useClientSort: false,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    columns: [
      {
        header: 'PROMOTION_COUPON_DETAIL_HEADER_MEMBER_NO',
        name: 'memberNo',
        align: 'center',
        minWidth: 85,
        formatter: function (data: any) {
          return `<a href="javascript:window.open(\'/member/popup/crm/${data.value}\',\'AccumulationPopup\',\'top=100, left=350, scrollbars=no, width=900, height=700, resizable=no\');" class="ordererPopup">${data.value}</a>`;
        },
        copyOptions: {
          useFormattedValue: false
        }
      },
      {
        header: 'PROMOTION_COUPON_DETAIL_HEADER_MEMBER_NAME',
        name: 'memberName',
        align: 'center',
        minWidth: 105
      },
      {
        header: 'PROMOTION_COUPON_DETAIL_HEADER_MEMBER_ID',
        name: 'memberId',
        align: 'center',
        minWidth: 105
      },
      {
        header: 'PROMOTION_COUPON_DETAIL_HEADER_MEMBER_GRADE',
        name: 'memberGradeName',
        align: 'center',
        minWidth: 105
      },
      {
        header: 'PROMOTION_COUPON_DETAIL_HEADER_COUPON',
        name: 'couponNo',
        align: 'center',
        minWidth: 85
      },
      {
        header: 'PROMOTION_COUPON_DETAIL_HEADER_ISSUE_YMDT',
        name: 'issueYmdt',
        align: 'center',
        minWidth: 135
      },
      {
        header: 'PROMOTION_COUPON_DETAIL_HEADER_USE_YDMT',
        name: 'used',
        align: 'center',
        minWidth: 80,
        formatter: (data: any) => {
          if (data.value) {
            return 'Y';
          } else {
            return 'N';
          }
        }
      }
    ]
  };
}
